export default {
  pass: 'Bestanden',
  fail: 'Nicht Bestanden',
};
